import React from 'react';
import {MarkerClusterer} from "@react-google-maps/api";
import Pin from "./Pin";

const MapElements = ({stations, setSelected}) => {
    return (
        <MarkerClusterer
            options={{
                imagePath:
                    "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m",
                styles: []
            }}
        >
            {clusterer =>
                stations.map((mark, i) => (
                    <Pin setSelected={setSelected} key={i} mark={mark} clusterer={clusterer}/>
                ))
            }

        </MarkerClusterer>
    );
}

export default MapElements;